export function startWorker() {
  const worker = new Worker(new URL('./LocationWorker', import.meta.url), {
    name: 'location-worker',
    type: 'module',
  });

  worker.onmessage = function (e) {
    console.debug('Received message from worker', e.data);
  };

  return worker;
}
